export default __webpack_public_path__ + "static/media/pic4.57f2b9cb.jpg";